'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELD_META_PROP = exports.FIELD_META_PROP = 'data-__meta';


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/form/constants.js
// module id = 1297
// module chunks = 0